import React from 'react';
import { Helmet } from 'react-helmet-async';
export function StructuredData() {
  const websiteSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: 'Laravel Recruitment Tests',
    alternateName: 'RecruitmentTest by Certification for Laravel',
    url: 'https://recruitmenttest.certificationforlaravel.com',
    description: 'Standardized, proctored recruitment tests to evaluate Laravel developer skills. Built by the Certification for Laravel community.',
    potentialAction: {
      '@type': 'SearchAction',
      target: 'https://recruitmenttest.certificationforlaravel.com/search?q={search_term_string}',
      'query-input': 'required name=search_term_string'
    }
  };
  const organizationSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: 'Certification for Laravel',
    url: 'https://certificationforlaravel.com',
    logo: 'https://cdn.magicpatterns.com/uploads/e5BUmyxLnn3e5mAPwSBoue/Recruitmenttest_logo_website.png',
    description: 'A community-driven, open-source certification program that validates real-world Laravel skills and experience.',
    sameAs: ['https://www.linkedin.com/company/certification-for-laravel/', 'https://medium.com/@certificationforlaravel', 'https://t.me/certificationforlaravel'],
    contactPoint: {
      '@type': 'ContactPoint',
      email: 'contact@certificationforlaravel.org',
      contactType: 'customer service'
    }
  };
  const professionalServiceSchema = {
    '@context': 'https://schema.org',
    '@type': 'ProfessionalService',
    name: 'Laravel Recruitment Tests',
    url: 'https://recruitmenttest.certificationforlaravel.com',
    description: 'Standardized technical assessments for hiring Laravel developers at Junior, Mid-Level, and Senior proficiency levels.',
    provider: {
      '@type': 'Organization',
      name: 'Certification for Laravel'
    },
    serviceType: 'Technical Skills Assessment',
    areaServed: 'Worldwide'
  };
  const productSchema = {
    '@context': 'https://schema.org',
    '@type': 'Product',
    name: 'Laravel Recruitment Tests',
    description: 'Proctored, standardized tests to evaluate Laravel developer skills for hiring. Available in Lite ($11) and Professional ($19) tiers across Junior, Mid-Level, and Senior proficiency levels.',
    brand: {
      '@type': 'Brand',
      name: 'Certification for Laravel'
    },
    offers: [{
      '@type': 'Offer',
      name: 'Lite Assessment',
      price: '11',
      priceCurrency: 'USD',
      priceValidUntil: '2026-12-31',
      availability: 'https://schema.org/InStock',
      description: 'Quick screening with Pass/Fail result and Score percentage.'
    }, {
      '@type': 'Offer',
      name: 'Professional Assessment',
      price: '19',
      priceCurrency: 'USD',
      priceValidUntil: '2026-12-31',
      availability: 'https://schema.org/InStock',
      description: 'Full analysis with detailed Strength/Weakness report.'
    }]
  };
  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [{
      '@type': 'Question',
      name: 'How do Laravel recruitment tests work?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'You buy test credits, send secure test links to candidates, and receive instant results with skill breakdowns. Each test contains 45 multiple-choice questions with code snippets. Candidates need 75% correct answers to pass. All tests are fully proctored with camera recording, screen lock, and anti-cheat AI analysis.'
      }
    }, {
      '@type': 'Question',
      name: 'How much do Laravel recruitment tests cost?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Lite Assessments cost $11 per test (Pass/Fail + Score). Professional Assessments cost $19 per test (Full Analysis + Strength/Weakness Report). Bulk discounts of 10% are available at every step (10, 20, 30+ tests). All credits are valid for 12 months.'
      }
    }, {
      '@type': 'Question',
      name: 'What Laravel skills are tested in the recruitment assessment?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Tests cover 12 core Laravel competencies: Service Providers, Blade Templating, Validation, Authorization (Gates & Policies), Queues and Jobs, Eloquent ORM, Middleware, Redis and Caching, Database Migrations, Testing (PHPUnit & Laravel Dusk), Security (CSRF & Encryption), and API Development.'
      }
    }, {
      '@type': 'Question',
      name: 'What proficiency levels are available for Laravel tests?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Tests are calibrated for three seniority levels: Junior (core syntax, basic MVC, standard coding practices), Mid-Level (architectural awareness, database optimization, design patterns), and Senior (system design, security, scalability, complex problem-solving).'
      }
    }, {
      '@type': 'Question',
      name: 'Are the Laravel recruitment tests proctored and secure?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Yes, all tests are fully proctored by Pruefster. Security measures include camera and sound recording, screen lock, no second screen allowed, no leaving the screen, anti-cheat AI analysis, human review, and ID identification. The platform is 100% EU-hosted and GDPR compliant.'
      }
    }, {
      '@type': 'Question',
      name: 'Who creates the Laravel recruitment test questions?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Tests are built by the Certification for Laravel community — a global network of certified developers, including a Board of Advisors, Exam Committee, Exam Reviewers, and Question Contributors. All questions reflect real-world Laravel development practices using Laravel 12.'
      }
    }]
  };
  return <Helmet data-id="element-371">
      <script type="application/ld+json" data-id="element-372">
        {JSON.stringify(websiteSchema)}
      </script>
      <script type="application/ld+json" data-id="element-373">
        {JSON.stringify(organizationSchema)}
      </script>
      <script type="application/ld+json" data-id="element-374">
        {JSON.stringify(professionalServiceSchema)}
      </script>
      <script type="application/ld+json" data-id="element-375">
        {JSON.stringify(productSchema)}
      </script>
      <script type="application/ld+json" data-id="element-376">{JSON.stringify(faqSchema)}</script>
    </Helmet>;
}